import { styled } from '@/stitches.config';
import { CSS } from '@stitches/react';

export const StyledMessage = styled('span', {
  color: '$darkBlue300',
  fontSize: '$md',
  lineHeight: '$6',
  marginLeft: '$2',
  textAlign: 'left',
});

export const StyledLink = styled('a', {
  fontSize: '$md',
  lineHeight: '$6',
});

export const radioGroupStyles: CSS = {
  textAlign: 'left',
};
